module.exports = __webpack_public_path__ + "static/heart-ba1595b8604ae451eb8bbbecba93ebdb.png";